<script>
  import { createEventDispatcher } from "svelte";

  import Input from "./input.svelte";
  import Path from "./path.svelte";

  import { _ } from "./utils.js";

  export let openapi;
  export let id;
  export let schema;
  export let required = false;
  export let disabled = undefined;
  export let value;
  export let errors;
  export let dirty;
  export let canBeSubmitted;
  export let loading;
  export let editable;
  export let currentPath;
  export let texts = undefined;
  export let extras = undefined;

  const dispatch = createEventDispatcher();
</script>

<div id="{ id }-field" class={ schema.type === 'boolean' && schema.format === 'swap' ? 'lt-swap' : 'lt-field' }>
  {#if editable}
    <Path current={ currentPath } on:message={ ({ detail }) => { dispatch('message', detail) } } />
  {/if}
  {#if schema.type === 'boolean' && schema.format === 'toggle'}
    <div class="toggle-contaner">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label>
        <span>{ _(`fields.${ id }.label`, texts, schema.title || id) }</span>
        <Input { id } { openapi } { schema } { required } { disabled } error={ errors && errors.length } { currentPath } { texts } { extras } bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading } bind:dirty={ dirty }>

          <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
            <slot name="array-widgets" { addArrayWidget } { removeArrayWidget } />
          </svelte:fragment>
          <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
            <slot name="wallet-yours" { value } { setValue } />
          </svelte:fragment>

        </Input>
      </label>
    </div>
  {:else if schema.type === 'boolean' && schema.format === 'swap'}
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class="swap">
      <Input { id } { openapi } { schema } { required } { disabled } error={ errors && errors.length } { currentPath } { texts } { extras } bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }>

        <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
          <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
        </svelte:fragment>
        <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
          <slot name="wallet-yours" { value } { setValue } />
        </svelte:fragment>

      </Input>
      <div class="swap-on">
        {#if schema.trueText}
          { _(`fields.${ id }.trueText`, texts, schema.trueText) }
        {:else}
          {@html _(`fields.${ id }.trueHtml`, texts, schema.trueHtml) }
        {/if}
      </div>
      <div class="swap-off">
        {#if schema.falseText}
          { _(`fields.${ id }.falseText`, texts, schema.falseText) }
        {:else}
          {@html _(`fields.${ id }.falseHtml`, texts, schema.falseHtml) }
        {/if}
      </div>
    </label>
  {:else}
    {#if !schema.noLabel && !schema.hidden}
      <label for={ id }>
        <span class="field-label">
          { _(`fields.${ id }.label`, texts, schema.title || id) }
        </span>
        {#if required}
          <span class="required">{ _("Required", texts, "Required") }</span>
        {/if}
      </label>
    {/if}
    <Input { id } { openapi } { schema } { required } { disabled } error={ errors && errors.length } { currentPath } { texts } { extras } bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading } bind:dirty={ dirty }>

      <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
        <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
      </svelte:fragment>
      <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
        <slot name="wallet-yours" { value } { setValue } />
      </svelte:fragment>

    </Input>
  {/if}

  {#if schema.description || errors}
    <label for={ id }>
      <span class="description">
        {#if schema.description}
          <div>{ _(`fields.${ id }.description`, texts, schema.description) }</div>
        {/if}
        {#if errors}
          {#each errors as error}
            <div class="error">{ error.message }</div>
          {/each}
        {/if}
      </span>
    </label>
  {/if}
</div>